import { render, staticRenderFns } from "./SysMessage.vue?vue&type=template&id=46ab99d3&scoped=true&"
import script from "./SysMessage.vue?vue&type=script&lang=js&"
export * from "./SysMessage.vue?vue&type=script&lang=js&"
import style0 from "./SysMessage.vue?vue&type=style&index=0&id=46ab99d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab99d3",
  null
  
)

export default component.exports